import React, { memo, useMemo } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin';
import classNames from 'classnames';

import styles from './style.module.scss';

export interface ILoadingProps extends SpinProps {
  className?: string;
  loading?: boolean;
  color?: string;
  children?: React.ReactChild;
}

export default function Loading(props: ILoadingProps) {
  const { color = 'rgba(255, 103, 0, 0.8)', style = {}, loading, spinning, className = '', ...ret } = props;
  const compareSpinning = spinning || loading;
  const compareStyle = useMemo(() => ({ color, ...style }), [style, color]);
  return (
    <Spin
      className={classNames(className, 'flex-row-nowrap flex-center-center', {
        [styles.loading]: !Boolean(props.children),
      })}
      style={compareStyle}
      spinning={compareSpinning}
      {...ret}
    />
  );
}

export const CardLoading = memo((props: ILoadingProps) => (
  <Loading
    className={classNames(props.className || '', styles.cardLoding)}
    indicator={<LoadingOutlined />}
    size="large"
    {...props}
  />
));

// export default React.memo(({ className = '', color = '#FF6700' }: ILoadingProps) => (
//   <p className={classNames(styles.loading, className, 'flex-row-nowrap flex-center-center')}>
//     <svg
//       version="1.1"
//       xmlns="http://www.w3.org/2000/svg"
//       x="0px"
//       y="0px"
//       width="40px"
//       height="40px"
//       viewBox="0 0 50 50"
//     >
//       <path
//         fill={color}
//         d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
//         transform="rotate(287.359 25 25)"
//       >
//         <animateTransform
//           attributeType="xml"
//           attributeName="transform"
//           type="rotate"
//           from="0 25 25"
//           to="360 25 25"
//           dur="0.6s"
//           repeatCount="indefinite"
//         ></animateTransform>
//       </path>
//     </svg>
//   </p>
// ));
